import {
  getConditionalRules,
  matchesConditionalShowIf,
  type JsonFormObjectSchema,
  type JsonFormSchema,
  type JsonFormSectionHeadingLevel,
} from "containers/admin/clients/client/components/form-builder/form-schema";

export const getNestedValueByPath = (source: unknown, path: string): unknown =>
  path.split(".").reduce<unknown>((acc, part) => {
    if (acc && typeof acc === "object" && part in acc) {
      return (acc as Record<string, unknown>)[part];
    }

    return undefined;
  }, source);

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const isObjectSchema = (field: JsonFormSchema): field is JsonFormObjectSchema =>
  field.type === "object" && !!field.properties;

export const isRequiredField = (
  schema: JsonFormObjectSchema,
  fieldName: string,
  formData: unknown,
  prefix = "",
): boolean => {
  if (schema.required?.includes(fieldName)) {
    return true;
  }

  return getConditionalRules(schema).some((rule) => {
    if (!rule.requiredFieldNames.includes(fieldName)) {
      return false;
    }

    const triggerFieldPath = prefix ? `${prefix}.${rule.triggerFieldName}` : rule.triggerFieldName;
    const triggerValue = getNestedValueByPath(formData, triggerFieldPath);

    return matchesConditionalShowIf(triggerValue, rule.showIf);
  });
};

export const getObjectHeadingLevel = (
  field: JsonFormObjectSchema,
): JsonFormSectionHeadingLevel => field["x-heading-level"] ?? "subsection";

const NEEDED_FOR_GENERATION_TOOLTIP = "Needed to generate campaign with writer";

export const getFieldGenerationTooltip = (
  schema: JsonFormObjectSchema,
  fieldName: string,
): string | undefined =>
  schema.properties[fieldName]?.["x-needed-for-generation"] === true
    ? NEEDED_FOR_GENERATION_TOOLTIP
    : undefined;
